export class ProductBenefit {
    public benefitId: number;
    public productId: number;

    public constructor(init?: Partial<ProductBenefit>) {
        Object.assign(this, init);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/product-benefit.model.ts